import { createRoute, useNavigate } from '@tanstack/react-router';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { ArrowIcon } from 'components/icons/ArrowIcon';
import { Button } from 'components/ui/Button';
import { privacyPolicyContent, RouterKey } from 'consts';
import { useLanguage } from 'context/language.context';
import { format } from 'date-fns';
import { arSA, enUS } from 'date-fns/locale';
import { StringKey } from 'dictionaries/string-key.enum';
import { capitalize, cn } from 'lib/utils';
import { Fragment, useEffect } from 'react';
import { rootRoute } from 'router';

export const PrivacyPolicy = () => {
  const { t, direction } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="flex flex-col items-start gap-8 pb-8 pt-28 md:pb-16 md:pt-36 px-4 md:px-28">
        <Button
          variant={'secondary'}
          className="bg-transparent gap-1 h-10 px-4 py-2.5 border-gray-600 hover:border-gray-600"
          onClick={() => navigate({ to: RouterKey.HOME_PAGE })}
        >
          <span className={cn(direction === 'ltr' && 'scale-x-[-1]')}>
            <ArrowIcon fill="#969696" height={20} width={20} />
          </span>
          <p className="text-gray-600">{t(StringKey.BACK)}</p>
        </Button>
        <h1 className="bg-clip-text bg-label-gradient text-transparent text-[30px] leading-[38px] md:text-4xl font-semibold">
          {capitalize(t(StringKey.PRIVACY_POLICY).toLowerCase())}
        </h1>
        <div className="flex flex-col gap-6">
          <p className="text-[18px] leading-[24px]">
            {t(StringKey.TERMS_LAST_UPDATED)}{' '}
            {format(new Date(2025, 9, 15), 'd MMMM y', {
              locale: direction === 'rtl' ? arSA : enUS,
            })}
          </p>
          {privacyPolicyContent.map(({ title, texts }, index) => (
            <Fragment key={index}>
              <h3 className="text-[18px] leading-[24px] font-semibold">
                {`${index + 1}.`} {t(title).toUpperCase()}
              </h3>
              <div className="flex flex-col gap-4">
                {texts.map((text, nestedIndex) => (
                  <p key={nestedIndex} className="text-[18px] leading-[24px]">
                    {t(text)}
                  </p>
                ))}
              </div>
            </Fragment>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
};

export const privacyPolicyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: RouterKey.PRIVACY_POLICY,
  component: PrivacyPolicy,
});
